<template>
  <div class="message" :class="{ show: visible }">
    <img class="icon" src="@/assets/images/common/message-info@2x.png" />
    <span class="content">{{ content }}</span>
  </div>
</template>
<script>
export default {
  name: 'Message',
  props: {
    content: {
      type: String,
      default: '',
    },
    interval: {
      type: Number,
      default: 2000,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible() {
      this.initTimer();
    },
  },
  created() {
    this.initTimer();
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  methods: {
    initTimer() {
      if (!this.visible) {
        return;
      }
      setTimeout(() => {
        this.$emit('update:visible', false);
      }, this.interval);
    },
  },
  beforeDestroy() {
    document.body.removeChild(this.$el);
  },
};
</script>
<style lang="scss" scoped>
.message {
  position: fixed;
  height: 42px;
  background: white;
  box-shadow: 0px 1px 14px 0px rgba(230, 230, 230, 1);
  border-radius: 5px;
  top: 76px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 12px 15px;
  box-sizing: border-box;
  font-size: 14px;
  opacity: 0;
  transition: all 0.3s;
  z-index: 9999;

  &.show {
    opacity: 1;
    top: 106px;
  }
}
.icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
</style>
